import store from "@/store";

import { colorNames, boolToIcons } from "@/libs/rcmTableFieldsFunction";
import { _updateData } from "@/api/esdata";
import { ipValidate } from "@/api/formValidate";
import { removeFromGroup } from "@/api/edge";
import { restartNginxMasterProcess } from "@/api/edges";

// import EdgeVersionBtn from "@/components/EdgeSetting/EdgeVersionBtn";
import Vue from "vue";
// Vue.component("EdgeVersionBtn", EdgeVersionBtn);

export const settingZoneExplain = (parentVue) => {
    return {
        description: "<p>The <strong>Edge</strong> is where the request will be handled.</p>",
    };
};
export const groupName = (parentVue) => {
    return {
        formRender: "FormInput",
        withForm: false,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            return h("TagList", {
                props: {
                    listData: params.row.groupName,
                    maxShow: "5",
                    title: vm.$i18n.t("edgesetting.groupName"),
                    width: "350",
                },
            });
        },
    };
};
export const serviceIP = (parentVue) => {
    return {
        formTypes: ["editForm"],
        validate: [
            {
                required: true,
                message: `${parentVue.$i18n.t("slbsetting.serviceIP")} ${parentVue.$i18n.t(
                    "rcmtable.validateEmptyText"
                )}`,
                trigger: "blur",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    ipValidate("serviceip", value).then((result) => {
                        if (!result.data.success) {
                            return callback(new Error(result.data.message));
                        }
                        callback();
                    });
                },
                trigger: "blur",
            },
        ],
    };
};
// export const serviceVersion = (parentVue) => {
//     return {
//         formRender: "FormInput",
//         withForm: false,
//         render: (h, params) => {
//             var vm = parentVue.$refs.rcmTable;
//             const p = h("p", `測試中${params.row.hostname}`);
//             const elements = [p];

//             return h("span", {}, elements);
//         },
//     };
// };
export const isEnabled = (parentVue) => {
    return {
        description:
            "<p>Toggle the status of edges, when <strong>disabled</strong>, the traffic won't send to this node.</p>",
        formTypes: ["editForm"],
        render: (h, params) => {
            var status = params.row.isenabled;
            var vm = parentVue.$refs.rcmTable;
            return h("i-switch", {
                props: {
                    value: status,
                    beforeChange() {
                        return new Promise((resolve) => {
                            vm.$Modal.confirm({
                                title: vm.$i18n.t("rcmtable.changeStatusText"),
                                content: vm.$i18n.t("rcmtable.confirmChangeStatusText"),
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    resolve();
                                },
                            });
                        });
                    },
                    disabled: vm.isEditBtnDisabled,
                },
                on: {
                    "on-change": (value) => {
                        params.row.isenabled = value;
                        delete params.row._index;
                        delete params.row._rowKey;
                        delete params.row._checked;
                        _updateData("rcm-edges", "index", params.row)
                            .then((result) => {
                                vm.$Notice.success({
                                    title: vm.$i18n.t("global.success"),
                                    desc: `${result.data.message}`,
                                });
                            })
                            .catch(function (error) {
                                vm.$Notice.warning({
                                    title: vm.$i18n.t("global.error"),
                                    desc: `${error}`,
                                });
                                vm.getTableData();
                            });
                    },
                },
            });
        },
    };
};
export const connectState = (parentVue) => {
    return {
        render: (h, params) => {
            let connected = parentVue.viewSlotInfo.edgeclients.includes(params.row._id);
            var iconType = boolToIcons({
                value: connected,
                falseToDash: false,
            });
            var iconColor = connected ? colorNames.green : colorNames.red;
            return h("Icon", {
                props: {
                    type: iconType,
                    color: iconColor,
                    size: 24,
                },
            });
        },
    };
};
export const hostname = (parentVue) => {
    return {
        withForm: false,
        render: (h, params) => {
            const p = h("p", params.row.hostname);

            const normalTag = h("Tag", {}, "normal");
            const protectTag = h("Tag", {}, "protect");

            const elements = [p];
            elements.push(params.row.serviceProvideType == "protect" ? protectTag : normalTag);
            return h("span", {}, elements);
        },
    };
};

export const action = (parentVue) => {
    return {
        width: 160,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;

            const actionDivArray = [];
            const editBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: vm.isEditBtnDisabled ? "md-eye" : "md-create",
                },
                on: {
                    click: () => {
                        vm.editItem(params.row);
                    },
                },
            });
            var dropdownItems = [];
            if (store.getters.isInAllGroupView) {
                if (!params.row.nginxMasterIsRunning) {
                    dropdownItems.push({
                        value: "restart",
                        title: vm.$t("rcmtable.restartText"),
                        modalTitle: vm.$t("rcmtable.restartText"),
                        modalContent: vm.$t("rcmtable.confirmRestartText"),
                        disabled: vm.isRestartBtnDisabled,
                    });
                }
                dropdownItems.push({
                    value: "delete",
                    title: vm.$t("rcmtable.deleteText"),
                    modalTitle: vm.$t("rcmtable.deleteText"),
                    modalContent: vm.$t("rcmtable.confirmDeleteText"),
                    disabled: vm.isDeleteBtnDisabled,
                });
            } else {
                dropdownItems.push({
                    value: "removeFromGroup",
                    title: vm.$i18n.t("edgesetting.removeFromGroup"),
                    modalTitle: vm.$i18n.t("edgesetting.removeFromGroup"),
                    modalContent: vm.$i18n.t("edgesetting.removeFromGroupText"),
                    disabled: vm.isEditBtnDisabled,
                });
            }

            // const edgeVersionBtn = h("EdgeVersionBtn", {
            //     props: {
            //         shape: "circle",
            //         icon: "md-albums",
            //         row: params.row,
            //         connected: parentVue.viewSlotInfo.edgeclients.includes(params.row._id),
            //         edgeChangeVersionStatus: vm.$store.state.edgeChangeVersionStatus[params.row._index],
            //         groupName: params.row.groupName,
            //     },
            //     on: {
            //         "on-click": (value) => {
            //             console.log(value);
            //         },
            //     },
            // });

            const moreBtn = h(
                "Dropdown",
                {
                    props: {
                        trigger: "click",
                        placement: "right",
                        transfer: true,
                    },
                    on: {
                        "on-click": (value) => {
                            var currentItem = dropdownItems.find((e) => e.value == value);
                            vm.$Modal.confirm({
                                title: currentItem.modalTitle,
                                content: currentItem.modalContent,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    const restartHandler = () => {
                                        restartNginxMasterProcess(params.row);
                                    };
                                    const deleteHandler = () => {
                                        let deleteItem = Object.assign({}, params.row);
                                        delete deleteItem._index;
                                        delete deleteItem._rowKey;

                                        vm.actionType = "delete";
                                        vm.updateData(vm.esIndex, "delete", deleteItem);
                                    };
                                    const removeFromGroupHandler = () => {
                                        removeFromGroup({
                                            nodeId: params.row.nodeId,
                                            groupName: vm.$store.state.queryGroupName,
                                        });
                                    };
                                    const defaultHandler = () => {
                                        currentItem
                                            .apiAction(params.row)
                                            .then((result) => {
                                                vm.$Notice.success({
                                                    title: vm.$i18n.t("global.success"),
                                                    desc: `${result.data.message}`,
                                                });
                                            })
                                            .catch(function (error) {
                                                vm.$Notice.warning({
                                                    title: vm.$i18n.t("global.error"),
                                                    desc: `${error}`,
                                                });
                                                // vm.getAllData();
                                            });
                                    };
                                    const actions = {
                                        restart: restartHandler,
                                        delete: deleteHandler,
                                        removeFromGroup: removeFromGroupHandler,
                                    };
                                    const action = actions[value] || defaultHandler;
                                    action();
                                },
                            });
                        },
                    },
                },
                [
                    h("a", [
                        h("Button", {
                            props: {
                                shape: "circle",
                                icon: "md-more",
                                key: params.index,
                            },
                        }),
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list",
                        },
                        [
                            dropdownItems.map(function (item) {
                                return h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: item.value,
                                            disabled: item.disabled,
                                        },
                                    },
                                    item.title
                                );
                            }),
                        ]
                    ),
                ]
            );
            if (vm.userCanIndex) {
                actionDivArray.push(editBtn);
            }

            // actionDivArray.push(edgeVersionBtn);
            actionDivArray.push(moreBtn);
            return h("div", actionDivArray);
        },
    };
};



// WEBPACK FOOTER //
// ./src/view/EdgeSetting/fields.js